import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { CorporateAccount } from '../models.common';

export interface CorporateAccountState extends EntityState<CorporateAccount, string> {
  loaded: boolean;
}

@StoreConfig({ name: 'corporate-accounts', idKey: 'id', resettable: true })
export class CorporateAccountStore extends EntityStore<CorporateAccountState> {
  constructor() {
    super({ loaded: false });
  }
}

const corporateDelegateStore: CorporateAccountStore = new CorporateAccountStore();
export default corporateDelegateStore;
